import { ConfirmSalaryModal } from './ConfirmSalaryModal';

export { ConfirmSalaryModal };
